module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/og-aoj_e-00a00d2636c6c9c6585101586ba33a75.png";